/**
 * Komal OS - Delay Store
 * Manages the delay list, stats, and close/escalate actions.
 */

import { create } from 'zustand';
import * as delayService from '../services/delayService';

const useDelayStore = create((set, get) => ({
  delays: [],
  selectedDelay: null,
  stats: null,
  isLoading: false,
  isSubmitting: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchDelays: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const response = await delayService.getDelays(params);
      set({ delays: response.data.delays || [], isLoading: false });
      return response.data.delays;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load delays';
      set({ error: message, isLoading: false });
      return [];
    }
  },

  fetchDelay: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const response = await delayService.getDelay(id);
      set({ selectedDelay: response.data.delay, isLoading: false });
      return response.data.delay;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load delay';
      set({ error: message, isLoading: false });
      return null;
    }
  },

  fetchStats: async () => {
    try {
      const response = await delayService.getDelayStats();
      set({ stats: response.data });
      return response.data;
    } catch (error) {
      return null;
    }
  },

  closeDelay: async (id, data) => {
    set({ isSubmitting: true, error: null });
    try {
      const response = await delayService.closeDelay(id, data);
      await get().fetchDelay(id);
      set({ isSubmitting: false });
      return { success: true, data: response.data };
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to close delay';
      set({ error: message, isSubmitting: false });
      return { success: false, error: message };
    }
  },

  escalateDelay: async (id, level) => {
    set({ isSubmitting: true, error: null });
    try {
      const response = await delayService.escalateDelay(id, level);
      await get().fetchDelay(id);
      set({ isSubmitting: false });
      return { success: true, data: response.data };
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to escalate delay';
      set({ error: message, isSubmitting: false });
      return { success: false, error: message };
    }
  },
}));

export default useDelayStore;
